import { io } from "socket.io-client";

// Use manual connect so we control when auth token is ready
// Determine the correct backend URL
const socket = io(import.meta.env.VITE_BASE_URL || undefined, {
    auth: {
        token: localStorage.getItem('token') || ''
    },
    autoConnect: false,  // Controlled connect — we connect after token is confirmed
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
    transports: ['websocket', 'polling'],
    timeout: 10000 // 10s timeout
});

// Auto-connect for all users (including guests) to enable public live updates
// But catch errors to prevent console spam if the server is unreachable
try {
    socket.connect();
} catch (e) {
    console.error('[SOCKET_INIT_ERROR]', e.message);
}

// Debug Listeners
socket.on('connect', () => {
    console.log('[SOCKET_CONNECTED]', socket.id);
});

socket.on('connect_error', (err) => {
    console.error('[SOCKET_CONNECTION_ERROR]', err.message);
});

socket.on('disconnect', (reason) => {
    console.log('[SOCKET_DISCONNECTED]', reason);
});

/**
 * Call after login — sets new JWT and reconnects.
 */
export const updateSocketToken = (token) => {
    if (token) {
        socket.auth.token = token;
        if (!socket.connected) {
            socket.connect();
        } else {
            // Reconnect to re-authenticate with new token
            socket.disconnect().connect();
        }
    } else {
        // Logout — disconnect cleanly
        socket.auth.token = '';
        socket.disconnect();
    }
};

export default socket;
